module.exports = __webpack_public_path__ + "img/wuzi.19e71140.png";